import { render, staticRenderFns } from "./CourseSalesFilter.vue?vue&type=template&id=6827b5f3&"
import script from "./CourseSalesFilter.vue?vue&type=script&lang=js&"
export * from "./CourseSalesFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports